<template>
  <div>
    <p v-if="parentID == '0'">{{getScriptNameByID(sourceId)}}</p>
    <ul>
      <scriptItem v-for="(item,index) in node" :key="index" :sourceId="sourceId" :item="item"></scriptItem>
    </ul>
  </div>

</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  export default {
    name: "OperatorScriptLayout",
    props:{
      type:String,
      parentID:{
        type:String,
        default:"0"
      },
      sourceId:{
        type:String,
        default:"0"
      }
    },
    components:{
      scriptItem:()=>import('@/components/OperatorScript/operatorScriptItem'),
    },
    computed:{
      node() {

        let uiiii = this.getScripts(this.sourceId);

          if (uiiii.length > 0) {
            return uiiii[0].values.filter(item => item.parent_id === this.parentID);
          } else {
            return [];
          }
      },
      ...mapGetters(['getScripts','getScriptNameByID'])
    }
  }
</script>

<style scoped>
.showScript{cursor: pointer;}
  iframe {width: 100%;height: 80vh}
  ul li{list-style: decimal;padding: 3px 0;}
.content{padding: 5px 0;}

</style>
